<form [formGroup]="eventForm" class="text-blueGray-700" (ngSubmit)="submit()">

  <div class="text-sm space-y-10 {{formStyle}}">

    @if (!isEditMode) {
      <ol class="flex w-full items-start" aria-label="Passos do registo">
        @for (step of steps; track step.label; let i = $index; let first = $first; let last = $last) {
          <li class="flex min-w-0 flex-1 flex-col items-center">
            <div class="flex w-full items-center">
              <span [ngClass]="first
                ? 'h-0.5 flex-1 bg-transparent'
                : i <= stepIndex
                  ? 'h-0.5 flex-1 bg-sky-600'
                  : 'h-0.5 flex-1 bg-neutral-200'"></span>
              <button type="button" (click)="goToStep(i)"
                      [attr.aria-current]="i === stepIndex ? 'step' : null"
                      [ngClass]="i === stepIndex
                        ? 'flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-sky-600 text-sm font-semibold text-white ring-4 ring-sky-100'
                        : i < stepIndex
                          ? 'flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-sky-600 text-sm font-semibold text-white'
                          : 'flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-neutral-200 text-sm font-semibold text-neutral-400'">
                @if (i < stepIndex) {
                  <i class="pi pi-check text-xs"></i>
                } @else {
                  {{ i + 1 }}
                }
              </button>
              <span [ngClass]="last
                ? 'h-0.5 flex-1 bg-transparent'
                : i < stepIndex
                  ? 'h-0.5 flex-1 bg-sky-600'
                  : 'h-0.5 flex-1 bg-neutral-200'"></span>
            </div>
            <span [ngClass]="i <= stepIndex
              ? 'mt-3 text-center text-sm font-semibold text-neutral-900'
              : 'mt-3 text-center text-sm font-medium text-neutral-400'">{{ step.label }}</span>
          </li>
        }
      </ol>
    }

    @if (isEditMode || stepIndex === 0) {
      <div>
        <p class="mb-4 text-base font-semibold text-neutral-900">Qual é a intenção desta ocorrência?</p>
        <div class="grid grid-cols-1 gap-4 sm:grid-cols-2">
          <button type="button" (click)="selectIntent('SEEKING')"
                  [ngClass]="eventForm.get('intent')?.value === 'SEEKING'
                    ? 'border-2 border-neutral-900 bg-white px-6 py-8 text-left'
                    : 'border border-neutral-200 bg-white px-6 py-8 text-left hover:border-neutral-400'">
            <span class="block text-base font-semibold text-neutral-900">À procura</span>
            <span class="mt-2 block text-sm text-neutral-500">Algo que se perdeu e está a ser procurado.</span>
          </button>
          <button type="button" (click)="selectIntent('FOUND')"
                  [ngClass]="eventForm.get('intent')?.value === 'FOUND'
                    ? 'border-2 border-neutral-900 bg-white px-6 py-8 text-left'
                    : 'border border-neutral-200 bg-white px-6 py-8 text-left hover:border-neutral-400'">
            <span class="block text-base font-semibold text-neutral-900">Encontrado</span>
            <span class="mt-2 block text-sm text-neutral-500">Algo que foi encontrado e pode ser reclamado.</span>
          </button>
        </div>
        @if (apiErrors.get('intent')) {
          <p class="mt-3 text-sm text-red-600">{{ apiErrors.get('intent') }}</p>
        }

        @if (!isEditMode) {
          <div class="mt-10">
            <p class="mb-4 text-base font-semibold text-neutral-900">Qual é a categoria?</p>
            <div class="grid grid-cols-1 gap-4 sm:grid-cols-2">
              @for (card of categoryCards; track card.code) {
                <button type="button" (click)="selectCategory(card.code)"
                        [ngClass]="category === card.code
                          ? 'group relative block aspect-[3/2] w-full overflow-hidden rounded-2xl border-2 border-neutral-900 text-left shadow-sm'
                          : 'group relative block aspect-[3/2] w-full overflow-hidden rounded-2xl border-2 border-transparent text-left shadow-sm transition duration-300 hover:-translate-y-1 hover:shadow-xl'">
                  <span class="absolute inset-0 bg-cover bg-center transition duration-500 group-hover:scale-105"
                        [style.background-image]="'url(assets/img/' + card.src + ')'"></span>
                  <span class="absolute inset-x-0 bottom-0 bg-neutral-950/50 px-5 py-4 transition duration-300 group-hover:bg-neutral-950/65">
                    <span class="block text-base font-bold uppercase tracking-wide text-white">{{ card.title }}</span>
                    <span class="mt-1 block line-clamp-2 text-xs leading-relaxed text-white/80">{{ card.description }}</span>
                  </span>
                </button>
              }
            </div>
            @if (apiErrors.get('category')) {
              <p class="mt-3 text-sm text-red-600">{{ apiErrors.get('category') }}</p>
            }
          </div>
        }
      </div>
    }

    @if (isEditMode || stepIndex === 1) {
      <div [ngClass]="isEditMode ? '' : 'grid grid-cols-1 items-start gap-6 lg:grid-cols-[minmax(0,1fr)_minmax(0,0.9fr)]'">
      <div class="space-y-10">
        <div>
          <app-text-input [formGroup]="eventForm" [value]="eventForm.value?.title" [formError]="apiErrors.get('title')"
            [maxLength]="50"
            id="title"
            label="{{category === 'PEOPLE' ? 'Nome da pessoa' : 'Título da ocorrência'}} (Obrigatório)"
          ></app-text-input>
        </div>

        <div>
          <app-text-area-input [formGroup]="eventForm" [value]="eventForm.value?.description" [maxLength]="250"
            [formError]="apiErrors.get('description')" id="description" label="Descrição"></app-text-area-input>
        </div>

        @if (category === 'DOCUMENT' || category === 'OTHER') {
          <div>
            <app-text-input [formGroup]="eventForm" [value]="eventForm.value?.identification"
              [formError]="apiErrors.get('identification')"
              [maxLength]="50" id="identification" label="Adicione um Identificador"
            ></app-text-input>
          </div>
        }

        @if (category === 'PEOPLE') {
          <div>
            <app-person-form [eventForm]="eventForm" [apiErrors]="apiErrors"></app-person-form>
          </div>
        }

        @if (category === 'DOCUMENT') {
          <div>
            <app-document-form [eventForm]="eventForm" [apiErrors]="apiErrors"></app-document-form>
          </div>
        }

        @if (category === 'VEHICLE') {
          <div>
            <app-vehicle-form [eventForm]="eventForm" [apiErrors]="apiErrors"></app-vehicle-form>
          </div>
        }

        <div>
          <app-select-input id="province" [formGroup]="eventForm" [options]="provinces"
            [formError]="apiErrors.get('province')" label="Província (Obrigatório)"></app-select-input>
        </div>

        <div>
          <app-calendar-input [formGroup]="eventForm" [formError]="apiErrors.get('eventDate')" id="eventDate"
            [maxDate]="eventMaxDate" label="Data da Ocorrência (Obrigatório)"></app-calendar-input>
        </div>

        <div>
          @if (!isAdmin) {
            <div class="mb-10">
              <p-checkbox id="contactHide" class="text-gray-500" styleClass="'text-gray-500'"
                formControlName="isContactPublic" [ariaLabel]="'Permitir exposição do contacto'"
                [binary]="true" inputId="contactHideInput"></p-checkbox>
              <label for="contactHideInput" class="ml-2 text-gray-600">Permitir exposição do contacto</label>
              @if (!isEditMode) {
                <p><small class="text-xs text-amber-700">* Os contactos são ocultados por padrão.
                  Para vê-los, é preciso fazer uma solicitação de contacto ao criador da ocorrência. Ao ativar esta opção,
                  o contacto ficará visível para o mundo.
                </small></p>
              }
            </div>
          }

          <div>
            <app-text-chip-input [formGroup]="eventForm" id="contact" label="Contacto (Obrigatório)" [maxChips]="2"
              [formError]="apiErrors.get('contact')"
              placeholder="Adicione até 2 contactos"></app-text-chip-input>
          </div>
        </div>

        <div>
          <app-text-input [formGroup]="eventForm" [value]="eventForm.value?.reward"
            [formError]="apiErrors.get('reward')"
            [maxLength]="100" placeholder="Adicione uma recompensa"
            id="reward" label="Recompensa"
          ></app-text-input>
        </div>
      </div>

      @if (!isEditMode) {
        <aside class="rounded-2xl border border-neutral-200 bg-neutral-50 p-6 lg:sticky lg:top-8">
          <p class="text-base font-semibold text-neutral-900">Você sabia</p>
          <div class="mt-4 space-y-4 text-sm leading-relaxed text-neutral-600">
            <p>No campo de contactos, pode usar vírgula, premir Enter ou clicar fora do campo para adicionar um contacto à lista. Podem ser adicionados 2 contactos.</p>
            <hr class="border-0 border-t border-dotted border-neutral-300">
            <p>Por razões de segurança, o seu contacto ficará oculto. Caso um usuário tenha informações relativas a esta ocorrência, pode solicitar o contacto ao criador por intermédio da plataforma.</p>
            <hr class="border-0 border-t border-dotted border-neutral-300">
            <p>O campo de recompensa é completamente opcional.</p>
          </div>
        </aside>
      }
      </div>
    }

    @if (!isEditMode && imageStepOpened) {
      <div [ngClass]="stepIndex === 2 ? 'my-6 grid grid-cols-1 items-start gap-6 lg:grid-cols-[minmax(0,1fr)_minmax(0,0.9fr)]' : 'hidden'">
        <div class="space-y-10">
          <div class="border-4 border-dotted border-neutral-300 p-4">
            <app-form-error [message]="apiErrors.get('eventImage')"></app-form-error>
            <app-file-upload (onFileUpdate)="onFileUpdate($event)"
              [fileType]="'image/jpeg, image/jpg, image/png'"></app-file-upload>
            @if (redactedPreview) {
              <figure class="mt-4">
                <figcaption class="mb-2 text-sm font-semibold text-neutral-900">Imagem com dados ocultos</figcaption>
                <img [src]="redactedPreview" alt="Imagem com as partes sensíveis desfocadas"
                     class="max-h-64 w-full rounded-xl border border-neutral-200 object-contain">
              </figure>
            }
            <header class="mt-4 text-center text-sm text-gray-500">
              <p>Formatos permitidos: PNG, JPG, JPEG. Tamanho máximo de 3Mb.</p>
            </header>
            @if (eventImage) {
              <div class="mt-4 flex flex-col items-center gap-2">
                <app-custom-button label="Ocultar partes sensíveis" size="sm" (pressed)="openRedact()"></app-custom-button>
              </div>
            }
          </div>
          @if (eventImage) {
            <div>
              <p class="mb-4 text-base font-semibold text-neutral-900">O conteúdo da imagem é explícito/forte?</p>
              <div class="grid grid-cols-1 gap-4 sm:grid-cols-2">
                <button type="button" (click)="selectExplicitImage(true)"
                        [ngClass]="eventForm.get('isExplicitImage')?.value === true
                          ? 'border-2 border-neutral-900 bg-white px-6 py-8 text-left'
                          : 'border border-neutral-200 bg-white px-6 py-8 text-left hover:border-neutral-400'">
                  <span class="block text-base font-semibold text-neutral-900">Sim</span>
                  <span class="mt-2 block text-sm text-neutral-500">A imagem só aparece depois de um clique.</span>
                </button>
                <button type="button" (click)="selectExplicitImage(false)"
                        [ngClass]="eventForm.get('isExplicitImage')?.value !== true
                          ? 'border-2 border-neutral-900 bg-white px-6 py-8 text-left'
                          : 'border border-neutral-200 bg-white px-6 py-8 text-left hover:border-neutral-400'">
                  <span class="block text-base font-semibold text-neutral-900">Não</span>
                  <span class="mt-2 block text-sm text-neutral-500">A imagem fica visível na ocorrência.</span>
                </button>
              </div>
            </div>
          }
        </div>
        <aside class="rounded-2xl border border-neutral-200 bg-neutral-50 p-6 lg:sticky lg:top-8">
          <p class="text-base font-semibold text-neutral-900">Você sabia</p>
          <div class="mt-4 space-y-4 text-sm leading-relaxed text-neutral-600">
            <p>Imagens com informações sensíveis, como fotografias de pessoas ou dados pessoais em documentos, devem ser editadas para ocultar essas informações.</p>
            <hr class="border-0 border-t border-dotted border-neutral-300">
            <p>Se a imagem for explícita ou forte, não fica exposta publicamente. Para a ver, é necessário clicar nela.</p>
          </div>
        </aside>
      </div>
    }

    <app-image-redact [file]="redactFile" [open]="redactOpen" (saved)="onImageRedacted($event)" (closed)="onRedactClosed()"></app-image-redact>

    @if (isEditMode && eventImage != null) {
      <div class="mb-10">
        <p class="mb-4 text-base font-semibold text-neutral-900">O conteúdo da imagem é explícito/forte?</p>
        <div class="grid grid-cols-1 gap-4 sm:grid-cols-2">
          <button type="button" (click)="selectExplicitImage(true)"
                  [ngClass]="eventForm.get('isExplicitImage')?.value === true
                    ? 'border-2 border-neutral-900 bg-white px-6 py-8 text-left'
                    : 'border border-neutral-200 bg-white px-6 py-8 text-left hover:border-neutral-400'">
            <span class="block text-base font-semibold text-neutral-900">Sim</span>
            <span class="mt-2 block text-sm text-neutral-500">A imagem só aparece depois de um clique.</span>
          </button>
          <button type="button" (click)="selectExplicitImage(false)"
                  [ngClass]="eventForm.get('isExplicitImage')?.value !== true
                    ? 'border-2 border-neutral-900 bg-white px-6 py-8 text-left'
                    : 'border border-neutral-200 bg-white px-6 py-8 text-left hover:border-neutral-400'">
            <span class="block text-base font-semibold text-neutral-900">Não</span>
            <span class="mt-2 block text-sm text-neutral-500">A imagem fica visível na ocorrência.</span>
          </button>
        </div>
      </div>
    }

  </div>

  @if (isEditMode || stepIndex === 2) {
    <div class="my-5 flex items-center justify-center space-x-2 space-y-2">
      <p-checkbox #termsAndCondtions id="termsConditions" class="text-gray-500" styleClass="'text-gray-500'"
        formControlName="termsConditions" [binary]="true" inputId="ny"></p-checkbox>
      <p class="text-center text-sm">Ao criar/adicionar uma ocorrência, você concorda com os <a
        class="cursor-pointer text-blue-600 underline" [href]="'/termos'" target="_blank">Termos de Uso e Políticas de Privacidade</a>
        do AngolaEncontra.</p>
    </div>
  }

  <div class="mb-5 mt-16 flex items-center justify-center gap-3">
    @if (!isEditMode && stepIndex > 0) {
      <app-ae-button label="Voltar" type="button" variant="plain" size="sm" (buttonClick)="previousStep()"></app-ae-button>
    }
    @if (!isEditMode && stepIndex < 2) {
      <app-ae-button label="Continuar" type="button" icon="pi pi-arrow-right" size="sm" variant="primary" (buttonClick)="nextStep()"></app-ae-button>
    }
    @if (isEditMode || stepIndex === 2) {
      <app-ae-button label="Submeter" [disabled]="!eventForm.get('termsConditions')?.value" type="submit" icon="pi pi-save" size="sm" variant="primary"></app-ae-button>
    }
  </div>

</form>
